import React, { useState } from "react";
import { View, Text, StyleSheet, ScrollView, SafeAreaView } from "react-native";
import CalendarView from "./components/CalendarView";
import EventList from "./components/EventList";
import EventDetails from "./components/EventDetails";
import AttendeeList from "./components/AttendeeList";
import { useTheme } from "../../context/ThemeContext";
import { EventsPageType } from "./index";
import { useContent } from "../../context/ContentContext";
import { withComponentEditor } from "../BaseComponent";
const componentType = "eventsPage";
// Sample events data for testing
const today = new Date();

const EventsPage = ({ content = {}, onComponentSelect }) => {
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [selectedDate, setSelectedDate] = useState(new Date());
	const theme = useTheme();
	const styles = useStyles();
	const { fetchContent, contentSnapshot } = useContent();
	const pageContent = fetchContent(componentType) || {};
	// Merge with default content
	const defaultContent = EventsPageType.getDefaultContent();
	const mergedContent = {
		...defaultContent,
		...content,
	};
	const handleEditor = () => {
		if (onComponentSelect) {
			onComponentSelect({
				componentType,
				sections: [
					{
						id: "general",
						title: "General Settings",
						properties: ["pageTitle", "pageIcon"],
					},
				],
				properties: {
					// General Settings
					pageTitle: {
						store: "content",
						type: "text",
						label: "Page Title",
						description: "The title of what your product page will be about. (e.g. Products, Books..., etc.)",
						value: pageContent.pageTitle,
					},
					pageIcon: {
						store: "content",
						type: "icon",
						label: "Page Icon",
						description: "The icon of what your product page will be about. (e.g. Products, Books..., etc.)",
						value: pageContent.pageIcon,
					},
				},
			});
		}
	};
	const handleEventSelect = (event) => {
		setSelectedEvent(event);
	};

	const handleDateSelect = (date) => {
		setSelectedDate(date);
	};

	return (
		<SafeAreaView style={styles.container}>
			<View style={styles.header}>
				<Text onPress={handleEditor} style={styles.title}>
					{pageContent.pageTitle}
				</Text>
			</View>
			{!selectedEvent ? (
				<>
					<View style={styles.calendarSection}>
						<CalendarView selectedDate={selectedDate} onDateSelect={handleDateSelect} events={mergedContent.events} />
					</View>

					<View style={styles.eventsSection}>
						<EventList events={mergedContent.events} selectedDate={selectedDate} onEventSelect={handleEventSelect} />
					</View>
				</>
			) : (
				<View style={styles.detailsOverlay}>
					<EventDetails event={selectedEvent} onClose={() => setSelectedEvent(null)} />
					{false && <AttendeeList eventId={selectedEvent.id} />}
				</View>
			)}
		</SafeAreaView>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			flex: 1,
			backgroundColor: theme.colors.systemBackground.primary,
		},
		header: {
			padding: theme.spacing.md,
			borderBottomWidth: 1,
			borderBottomColor: theme.colors.separator,
			backgroundColor: theme.colors.systemBackground.primary,
			...theme.shadows.sm,
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
		},
		title: {
			...theme.typography.title1,
			color: theme.colors.text,
		},
		content: {
			flex: 1,
		},
		calendarSection: {
			borderBottomWidth: 1,
			borderBottomColor: theme.colors.separator,
			backgroundColor: theme.colors.systemBackground.primary,
			paddingVertical: theme.spacing.md,
			...theme.shadows.sm,
		},
		eventsSection: {
			flex: 1,
			backgroundColor: theme.colors.systemBackground.primary,
		},
		detailsOverlay: {
			flex: 1,
			backgroundColor: theme.colors.systemBackground.primary,
			zIndex: 1000,
			...theme.shadows.lg,
		},
		noEventSelected: {
			flex: 1,
			justifyContent: "center",
			alignItems: "center",
			padding: theme.spacing.lg,
		},
		noEventText: {
			color: theme.colors.textSecondary,
			...theme.typography.body,
			textAlign: "center",
		},
	});
};

export default withComponentEditor(EventsPage);
